<template>
  <v-app>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <Header />
          <v-card class="mx-4 py-1 mt-9 mb-n5 theme" style="z-index: 1">
            <v-card-title primary-title>
              <v-spacer></v-spacer>
              <div class="white--text display-1 font-weight-light">
                Change password
              </div>
              <v-spacer></v-spacer>
            </v-card-title>
          </v-card>
          <v-card class="elevation-0">
            <v-card-text>
              <div class="my-3">
                <v-btn
                  plain
                  small
                  class="caption theme-text text-capitalize"
                  @click="redirectToRegister"
                  >Register
                </v-btn>
                <v-btn
                  plain
                  small
                  class="caption theme-text text-capitalize"
                  @click="redirectToLogin"
                  style="float: right"
                  >login
                </v-btn>
                <div style="clear: both"></div>
              </div>
              <v-alert :value="alertShow" :type="alertType">{{
                alertText
              }}</v-alert>
              <v-form ref="form" v-model="valid">
                <v-text-field
                  v-model="email"
                  label="Email"
                  type="email"
                  class="px-3"
                  placeholder="Registered Email"
                  :autofocus="true"
                  disabled
                  autocomplete="email"
                />
                <v-text-field
                  v-model="password"
                  label="New password *"
                  type="password"
                  class="px-3"
                  placeholder="New password"
                  :autofocus="true"
                  tabindex="1"
                  validate-on-blur
                  :rules="[validationRules.password, validationRules.required]"
                />
                <v-text-field
                  v-model="confirmPassword"
                  label="Confirm password *"
                  type="password"
                  class="px-3"
                  validate-on-blur
                  placeholder="confirm password"
                  tabindex="2"
                  :rules="[confirmPasswordRules]"
                />
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn
                class="action white--text rounded-sm mr-2"
                small
                depressed
                tabindex="2"
                @click="changePassword"
                >Reset Password
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import Header from "@/components/Header";
import { Actions } from "@/views/actions";
import { Component } from "@/views/component";
import { Constants } from "@/views/constants";

export default {
  name: Component.Auth.ChangePassword,
  components: { Header },
  data: () => {
    return {
      alertShow: false,
      alertType: "warning",
      alertText: "",
      valid: true,
      password: "",
      confirmPassword: "",
      email: "",
      oobCode: "",
      namespace: "",
      activation_code: "",
      company_id: "",
    };
  },
  computed: {
    confirmPasswordRules() {
      if (!this.confirmPassword) return Constants.ConfirmPassword.Required;
      if (this.password === this.confirmPassword) return true;
      return Constants.ConfirmPassword.DoesNotMatch;
    },
  },
  methods: {
    redirectToRegister() {
      this.$router.push({ name: Component.Auth.Register });
    },
    redirectToLogin() {
      this.$router.replace("/");
    },
    changePassword() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch(Actions.Firebase.Reset, {
            oobCode: this.oobCode,
            password: this.password,
          })
          .then(() => {
            // company_id is sent in the query params only for employee invites.
            // this check is for the employee invites. The regular employees
            // need to set their password before activation. the password change
            // is done on this page and activation is done explicitly by the code below.
            if (this.company_id !== "") {
              // send a redirect
              this.$store
                .dispatch(Actions.Auth.ActivateEmp, {
                  email: this.email,
                  companyID: this.company_id,
                  namespace: this.namespace,
                })
                .catch((e) => {
                  this.alertShow = true;
                  this.alertText = "Invalid activation link";
                  this.alertType = "warning";
                  console.error("error explicitly activating user", e);
                });
            }
            this.alertShow = true;
            this.alertText = "Password changed successfully";
            this.alertType = "success";
            setTimeout(() => this.$router.replace("/"), 1000);
          })
          .catch((e) => {
            console.error(e);
            this.alertShow = true;
            this.alertType = "warning";

            switch (e.code) {
              case "auth/expired-action-code":
                this.alertText = "Activation code has expired.Please try again";
                break;
              case "auth/invalid-action-code":
                this.alertText = "Activation code is invalid. Please try again";
                break;
              case "auth/user-disabled":
                this.alertText =
                  "Account inactive. Please activate your account before resetting password. Check your inbox for the welcome email from LessAdmin";
                break;
              case "auth/user-not-found":
                this.alertText = "Your account is not registered with us.";
                break;
              case "auth/weak-password":
                this.alertText =
                  "Your password is extremely weak. Please provide a stronger password";
                break;
              default:
                this.alertText = "Your password reset link has expired.";
            }
          });
      }
    },
    getUser() {
      let data = {
        namespace: this.namespace,
        activation_code: this.activation_code,
      };
      this.$store
        .dispatch(Actions.Auth.UserByCode, data)
        .then((r) => {
          if (r.status === 200) {
            this.email = r.data.email;
          } else if (r.status === 400) {
            this.alertShow = true;
            this.alertText = "Invalid activation code";
            this.alertType = "warning";
          }
        })
        .catch((e) => {
          console.error("here", e);
        });
    },
  },
  created() {
    console.log(this.$route.query.activation_code);
    console.log(this.$route.query.oobCode);
    console.log(this.$route.query.namespace);
    console.log(this.$route.query.companyID);
    this.namespace = this.$route.query.namespace;
    this.activation_code = this.$route.query.activation_code;
    this.oobCode = this.$route.query.oobCode;
    this.company_id = this.$route.query.companyID;
    if (!this.namespace || !this.activation_code || !this.oobCode) {
      this.alertShow = true;
      this.alertText =
        "Your activation link has expired or is invalid. Please retry.";
      this.alertType = "warning";
      return false;
    }

    this.getUser();
  },
};
</script>

<style  scoped>
.container {
  /*background: radial-gradient(#c4a0eb, #542aff) no-repeat;*/
  background: radial-gradient(#9c1a5f, #551738) no-repeat;
  place-items: center center;
}

div.v-alert {
  border-radius: 5px;
}

.v-input {
  font-weight: 300;
}
</style>
